import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, Row} from "react-bootstrap";
import {FadeLoader} from "react-spinners";
import {useHistory} from "react-router-dom";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import {EmptyLocalStorage} from "../../services/auth/auth.service";
import {GetMusicById, UpdateMusic} from "../../services/music.service";
import {uploadToS3} from "../../utils/helpers";

function EditMusic(props) {
    let history = useHistory();
    const audioRef = useRef(null);
    const [data, setData] = useState({});
    const [loader, setLoader] = useState(false);
    const [music, setMusic] = useState()
    const [duration, setDuration] = useState(0);
    const [isUpload, setIsUpload] = useState(false)
    const [file, setFile] = useState(null)
    const [isUploadOverWrite, setIsUploadOverWrite] = useState(false)
    const [image, setImage] = useState()
    const [imageFile, setImageFile] = useState(null)
    const [isImageUpload, setIsImageUpload] = useState(false)
    const [isImageUploadOverWrite, setImageIsUploadOverWrite] = useState(false)
    const {register, watch,setValue, handleSubmit, setError, clearErrors, formState: {errors}} = useForm({
        mode: "onBlur",
    });

    useEffect(async () => {
        let id = props.match.params.id;
        await getMusicByid(id);

    }, [])

    const getMusicByid = async (id) => {
        await GetMusicById(id).then((result) => {
            if (result.status) {
                if (result.data) {
                    setData(result.data);
                    setValue("title", result.data?.title);
                    setValue("cast", result.data?.cast);
                    setValue("status", (result.data?.status && result.data?.status == true ? "1":"0"));
                    if(result.data?.attachments[0].path){
                        setMusic(result.data?.attachments[0].path)
                        setDuration(result.data?.attachments[0].duration)
                        setIsUpload(true)
                    }
                    if(result.data?.image){
                        setImage(result.data?.image)
                        setIsImageUpload(true)
                    }

                }
            } else {
                return toast.error(result.message);
            }


        }).catch((error) => {
            setLoader(false);
            if (error.response.status === 401) {
                EmptyLocalStorage();
                history.push('/');
            } else {
                if (error.response.data.status === false && error.response.data.message && error.response.data.data && Array.isArray(error.response.data.data)) {
                    const errorMessages = error.response.data.data.map((message) => message).join(", ");
                    toast.error(`${error.response.data.message}: ${errorMessages}`);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        })
    }



    const onSubmit = async data => {
        if(isUploadOverWrite){
        if(file.type.startsWith('audio/')){
            clearErrors('media')
        }else{
            setError('media',{message:'Invalid file type'})
            return false;
        }}
        if(isImageUploadOverWrite){
            if(imageFile.type.startsWith('image/')){
                clearErrors('image')
            }else{
                setError('image',{message:'Invalid file type'})
                return false;
            }}
        setLoader(true)
        if(isUploadOverWrite){
            if (!file){
                setError('media' ,{message:"Audio is required"})
            }

            let uploadAudio = await uploadToS3(file.type,file.name,file,'music');

            if (uploadAudio) {
                if (!uploadAudio) {
                    setLoader(false)
                    toast.error(uploadAudio.message);
                    return false;
                }
            } else {
                setLoader(false)
                toast.error('Can\'t Upload Audio');
                return false;
            }
            data.media=uploadAudio;
        }else{
            data.media=music
        }
        if(isImageUploadOverWrite){
            if (!imageFile){
                setError('image' ,{message:"Image is required"})
            }

            let uploadImage = await uploadToS3(imageFile.type,imageFile.name,imageFile,'music');

            if (uploadImage) {
                if (!uploadImage) {
                    setLoader(false)
                    toast.error(uploadImage.message);
                    return false;
                }
            } else {
                setLoader(false)
                toast.error('Can\'t Upload Image');
                return false;
            }
            data.image=uploadImage;
        }else{
            data.image=image;
        }
        let id = props.match.params.id;
        let dt = {
            title: data.title || '-',
            cast: data.cast ,
            image: data.image,
                attachments:[{
                duration: duration,
                is_feature: true,
                mime_type: "audio",
                 path: data.media ,
                type: 20
            }],
            status: (data?.status && data?.status==1 ? true: false ),

        }

        await UpdateMusic(id, dt).then(async (data) => {
            setLoader(false)
            if (data.status) {
                toast.success(data.message);
                history.push('/musics');
            } else {
                setLoader(false)
                toast.error(data.message);
            }
        }).catch((error) => {
            setLoader(false);
            if (error.response.status === 401) {
                EmptyLocalStorage();
                history.push('/');
            } else {
                if (error.response.data.status === false && error.response.data.message && error.response.data.data && Array.isArray(error.response.data.data)) {
                    const errorMessages = error.response.data.data.map((message) => message).join(", ");
                    toast.error(`${error.response.data.message}: ${errorMessages}`);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        })


    };

    const uploadFile = async (fileInput) => {
        let fileUrl = URL.createObjectURL(fileInput[0])
        setMusic(fileUrl)
        setFile(fileInput[0])
        setIsUpload(true)
        if(fileUrl){
            setIsUploadOverWrite(true)
            clearErrors('media')
        }

    }

    const handleLoadedMetadata = () => {
        setDuration( Math.round(audioRef.current?.duration));
    }

    const uploadImageFile = async (fileInput) => {

        let fileUrl = URL.createObjectURL(fileInput[0])
        setImage(fileUrl)
        setImageFile(fileInput[0])
        setIsImageUpload(true)
        if(fileUrl){
            setImageIsUploadOverWrite(true)
            clearErrors('image')
        }

    }
    return (
        <div className="EditMusic">
            {/*<BreadcrumbsComponent />*/}
            <h3 className="page-heading">Edit Music</h3>
            <hr/>
            <Row>
                <Col xs={12} sm={12} md={10} lg={12} xl={6}>
                    <Form className="formAddUser" autoComplete="off" role="presentation"
                          onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="image">
                                    <Form.Label>Image* <Form.Text className=" text-muted" style={{fontSize:".675em"}}>(Max upload file size: 5 GB)</Form.Text> </Form.Label>
                                    <input
                                        {...register('image')}
                                        onChange={(e) => uploadImageFile(e.target.files)}
                                        type='file'
                                        accept={'.jepg,.jpg,.png'}
                                        class="custom-file-input"
                                        id='image'

                                    />

                                    {errors.image && <Form.Text
                                        className=" validationText hasError">{errors.image.message}</Form.Text>}
                                    <br/>
                                    {isImageUpload ?
                                        <img  src={image} type="image" className={"img-table img-thumbnail mt-2"} controls crossOrigin="anonymous" />:  ""
                                    }
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="image">
                                    <Form.Label>Media* <Form.Text className=" text-muted" style={{fontSize:".675em"}}>(Max upload file size: 5 GB)</Form.Text> </Form.Label>
                                    <br/>
                                    <input
                                        {...register('media')}
                                        onChange={(e) => uploadFile(e.target.files)}
                                        type='file'
                                        accept={'.mp3'}
                                        class="custom-file-input"
                                        id='image'

                                    />

                                    <br/>
                                    {errors.media && <Form.Text
                                        className=" validationText hasError">{errors.media.message}</Form.Text>}
                                    {isUpload ?
                                        <audio ref={audioRef} src={music} type="audio/acc" className={"mt-2"} controls crossOrigin="anonymous" onLoadedMetadata={handleLoadedMetadata}/>:  ""
                                    }
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="title">
                                    <Form.Label>Title*</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Title"

                                        {...register('title', {
                                            required: {
                                                value: "required",
                                                message: "Title is required"
                                            },
                                            pattern:{
                                                value:/^(?!\s).*$/,
                                                message:"Title should not start with a space"
                                            },
                                            minLength: {
                                                value: 3,
                                                message: "Min length is 3"
                                            },
                                            maxLength: {
                                                value: 100,
                                                message: "Max length is 100"
                                            },
                                        })} type="text"
                                    />
                                    {errors.title && <Form.Text
                                        className=" validationText hasError">{errors.title.message}</Form.Text>}

                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="cast">
                                    <Form.Label>Cast*</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Cast"

                                        {...register('cast', {
                                            required: {
                                                value: "required",
                                                message: "Cast is required"
                                            },
                                            pattern:{
                                                value:/^(?!\s).*$/,
                                                message:"Cast should not start with a space"
                                            },
                                            minLength: {
                                                value: 3,
                                                message: "Min length is 3"
                                            },
                                            maxLength: {
                                                value: 100,
                                                message: "Max length is 100"
                                            },
                                        })} type="text"
                                    />
                                    {errors.cast && <Form.Text
                                        className=" validationText hasError">{errors.cast.message}</Form.Text>}

                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col  xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className={"mb-3"} controlId="status">
                                    <Form.Label className='d-block'>Select Status*</Form.Label>
                                    <Form.Select className='formselect' aria-label="status" {...register('status', {
                                        required: {
                                            value: "required",
                                            message: "Status is required"
                                        }
                                    })}>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </Form.Select>
                                    {errors.status && <Form.Text
                                        className=" validationText hasError">{errors.status.message}</Form.Text>}
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col  xs={12} sm={12} md={8} lg={6} xl={6}>
                                {loader ? <div className="spin-loader">
                                        <FadeLoader color={"#41D2D2"} height={10}/>
                                    </div> :
                                    <input type={"submit"} className={"btn btn-green-theme w-100 mt-3"}
                                           value={"Update Music"}/>}
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>

        </div>
    );
}

export default EditMusic;